export default { //buat yg muncul di kiri.
	items: [
		{
			name: 'Dashboard',
			url: '/dashboard',
			icon: 'fa fa-square',
			code: 'DAS'
		},
		{
			name: 'Master',
			url: '/master',
			icon: 'fa fa-square',
			code: 'MST',
			children: [
				{
					name: 'Tipe Pinjaman',
					url: '/master/tipe-pinjaman',
					code: 'MTP',
				},
				{
					name: 'Jenis Barang',
					url: '/master/jenis-barang',
					code: 'MJE',
				},
				{
					name: 'Merk Barang',
					url: '/master/merk-barang',
					code: 'MME',
				},
				{
					name: 'Tipe Barang',
					url: '/master/tipe-barang',
					code: 'MTI',
				},
				{
					name: 'Atribut Jenis Barang',
					url: '/master/atribut-jenis-barang',
					code: 'MAJ',
				},
				{
					name: 'Cabang',
					url: '/master/cabang',
					code: 'MCA',
				},
				{
					name: 'Anggota',
					url: '/master/anggota',
					code: 'MAN',
				},
				{
					name: 'User Staff',
					url: '/master/user-staff',
					code: 'MUS',
				},
				{
					name: 'Role',
					url: '/master/role',
					code: 'MRO',
				},
				{
					name: 'Promo',
					url: '/master/promo',
					code: 'MPR',
				},
				{
					name: 'Wilayah',
					url: '/master/wilayah',
					code: 'MWI',
					// Menu ini belum tampil di sidebar karena backend belum punya
					// kode menu MWI (EnumMenu) dan belum memberikannya ke role.
					// Halamannya tetap bisa dibuka lewat URL /master/wilayah.
					// Untuk memaksa tampil saat development, aktifkan baris di bawah
					// DAN kembalikan dukungan alwaysShow pada filter di
					// containers/DefaultContainer.vue (checkChildren).
					// alwaysShow: true,
				},
				{
					name: 'Parameter',
					url: '/master/parameter',
					code: 'MPA',
				},
				{
					name: 'Akses Menu',
					url: '/master/akses-menu',
					code: 'MAK',
				},
			]
		},
		{
			name: 'Gadai',
			url: '/gadai',
			icon: 'fa fa-square',
			code: 'GAD',
			children: [
				{
					name: 'Pengajuan Gadai',
					url: '/gadai/pengajuan-gadai',
					code: 'GAI',
				},
				// {
				// 	name: 'Elektronik',
				// 	url: '/gadai/elektronik',
				// 	code: 'GEL',
				// },
				// {
				// 	name: 'Kendaraan',
				// 	url: '/gadai/kendaraan',
				// 	code: 'GKE',
				// },
				{
					name: 'Simulasi Gadai',
					url: '/gadai/simulasi',
					code: 'GSI',
				},
				{
					name: 'Perpanjangan',
					url: '/gadai/perpanjangan',
					code: 'GPP',
				},
				{
					name: 'Pelunasan',
					url: '/gadai/pelunasan',
					code: 'GPL',
				},
				{
					name: 'Daftar Gadai',
					url: '/gadai/daftar',
					code: 'GDA',
				},
				{
					name: 'Pencarian Faktur',
					url: '/gadai/inquiry-faktur',
					code: 'GIF',
				},
				{
					name: 'Daftar Penarikan',
					url: '/gadai/daftar-penarikan',
					code: 'GDP',
				}
			]
		},
		{
			name: 'Persetujuan',
			url: '/persetujuan',
			icon: 'fa fa-square',
			code: 'STJ',
			children: [
				{
					name: 'Cek Gadai',
					url: '/persetujuan/cek-gadai',
					code: 'SCE',
				},
				{
					name: 'Edit Gadai',
					url: '/persetujuan/edit-gadai',
					code: 'SED',
				},
				{
					name: 'Keringanan',
					url: '/persetujuan/keringanan',
					code: 'SKE',
				},
				{
					name: 'Void Pembayaran',
					url: '/persetujuan/void-pembayaran',
					code: 'SVO',
				},
				{
					name: 'Kas Keluar',
					url: '/persetujuan/kas-keluar',
					code: 'SKK',
				},
				{
					name: 'Barang Hilang',
					url: '/persetujuan/barang-hilang',
					code: 'SBH',
				}
			]
		},
		{
			name: 'Pusat',
			url: '/pusat',
			icon: 'fa fa-square',
			code: 'PST',
			children: [
				{
					name: 'Daftar Void Gadai',
					url: '/pusat/daftar-void-gadai',
					code: 'PVG',
				},
				{
					name: 'Daftar Void Pembayaran',
					url: '/pusat/daftar-void-pembayaran',
					code: 'PVP',
				},
				{
					name: 'Daftar Cek Gadai',
					url: '/pusat/daftar-cek-gadai',
					code: 'PCG',
				},
				{
					name: 'Daftar Edit Gadai',
					url: '/pusat/daftar-edit-gadai',
					code: 'PEG',
				},
				{
					name: 'Surat BPKB',
					url: '/pusat/surat-bpkb',
					code: 'PSB'
				},
				{
					name: 'Daftar Penarikan',
					url: '/pusat/daftar-penarikan',
					code: 'PDP'
				},
				{
					name: 'SMS',
					url: '/pusat/sms',
					code: 'PSM'
				},
				{
					name: 'Monitoring IP',
					url: '/pusat/monitoringip',
					code: 'PMI'
				}
			]
		},
		{
			name: 'Kasir',
			url: '/kasir',
			icon: 'fa fa-square',
			code: 'KSR',
			children: [
				{
					name: 'Transaksi Gadai',
					url: '/kasir/transaksi-gadai',
					code: 'KTG',
				},
				{
					name: 'Transaksi Pembayaran',
					url: '/kasir/transaksi-pembayaran',
					code: 'KTP',
				},
				{
					name: 'Kas Mutasi',
					url: '/kasir/kas-mutasi',
					code: 'KKA',
				},
				{
					name: 'Transaksi Kas Masuk',
					url: '/kasir/transaksi-kas-masuk',
					code: 'KKM',
				},
				{
					name: 'Transaksi Kas Keluar',
					url: '/kasir/transaksi-kas-keluar',
					code: 'KKK',
				},
			]
		},
		{
			name: 'Informasi Umum',
			url: '/informasi-umum',
			icon: 'fa fa-square',
			code: 'INF',
		},
		{
			name: 'Lelang',
			url: '/lelang',
			icon: 'fa fa-square',
			code: 'LEL',
			children: [
				{
					name: 'Order Lelang',
					url: '/lelang/order-lelang',
					code: 'LBA',
				},
				{
					name: 'Persiapan Lelang',
					url: '/lelang/persiapan-lelang',
					code: 'LPE',
				},
				{
					name: 'Penjualan',
					url: '/lelang/penjualan',
					code: 'LPJ',
				},
				{
					name: 'Kirim Balik',
					url: '/lelang/kirim-balik',
					code: 'LKB',
				}
			]
		},
		{
			name: 'Laporan',
			url: '/laporan',
			icon: 'fa fa-square',
			code: 'LAP',
			children: [
				{
					name: 'Laporan Stok Gudang',
					url: '/laporan/laporan-stok-gudang',
					code: 'RSG',
				},
				{
					name: 'Laporan Pembayaran',
					url: '/laporan/laporan-pembayaran',
					code: 'RPB',
				},
				{
					name: 'Laporan Pelunasan',
					url: '/laporan/laporan-pelunasan',
					code: 'RPL',
				},
				{
					name: 'Laporan Kas Masuk',
					url: '/laporan/laporan-kas-masuk',
					code: 'RMA',
				},
				{
					name: 'Laporan Kas Keluar',
					url: '/laporan/laporan-kas-keluar',
					code: 'RKE',
				},
				{
					name: 'Laporan Kas Mutasi',
					url: '/laporan/laporan-kas-mutasi',
					code: 'RMU',
				},
				{
					name: 'Laporan Buku Besar',
					url: '/laporan/laporan-buku-besar',
					code: 'RBB',
				},
				{
					name: 'Laporan Kas Cabang',
					url: '/laporan/laporan-kas-cabang',
					code: 'RKC',
				},
				{
					name: 'Laporan Kembar IMEI / SN',
					url: '/laporan/laporan-kembar-imei',
					code: 'RKI',
				},
			]
		},
		{
			name: 'Laporan Harian Cabang',
			url: '/laporan-harian-cabang',
			icon: 'fa fa-square',
			code: 'LHC',
			children: [
				{
					name: 'Serah Terima Gadai',
					url: '/laporan-harian-cabang/serah-terima-gadai',
					code: 'CGB',
				},
				{
					name: 'Serah Terima Gadai Lunas',
					url: '/laporan-harian-cabang/serah-terima-gadai-lunas',
					code: 'CGL',
				},
				{
					name: 'Transaksi Harian',
					url: '/laporan-harian-cabang/transaksi-harian',
					code: 'CTH',
				}
			]
		},
		{
			name: 'Laporan Eksekutif',
			url: '/laporan eksekutif',
			icon: 'fa fa-square',
			code: 'EKS',
			children: [
				{
					name: 'Laporan Omzet',
					url: '/laporan-eksekutif/laporan-omzet',
					code: 'EOM',
				},
				{
					name: 'Laporan Gadai Baru',
					url: '/laporan-eksekutif/laporan-gadai-baru',
					code: 'EGB',
				},
				{
					name: 'Laporan Pemasukan',
					url: '/laporan-eksekutif/laporan-pemasukan',
					code: 'EPE',
				},
				// {
				// 	name: 'Laporan PP/ PL',
				// 	url: '/laporan-eksekutif/laporan-pp-pl',
				// 	code: 'EPL',
				// },
				{
					name: 'Daftar BPKB Macet',
					url: '/laporan-eksekutif/daftar-bpkb-macet',
					code: 'EBM',
				},
				{
					name: 'Daftar Gadai Aktif',
					url: '/laporan-eksekutif/daftar-gadai-aktif',
					code: 'EGA',
				},
				{
					name: 'Laporan Penjualan',
					url: '/laporan-eksekutif/laporan-penjualan',
					code: 'EJU',
				}
			]
		},
		{
			name: 'Akses Laporan Eksekutif',
			url: '/akses-laporan-eksekutif',
			icon: 'fa fa-square',
			code: 'ALE',
		},
	]
}
